import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import paymentService from '../../services/payment';
import restPaymentService from '../../services/rest/payment';

const initialState = {
  loading: false,
  actionLoading: false,
  payments: [],
  error: '',
};

const normalizePaymentsList = (payload) => {
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }
  if (Array.isArray(payload)) {
    return payload;
  }
  return [];
};

export const fetchPayments = createAsyncThunk(
  'payment/fetchPayments',
  (params = {}) => {
    return paymentService.getAll(params).then((res) => res);
  }
);

export const fetchRestPayments = createAsyncThunk(
  'payment/fetchRestPayments',
  (params = {}) => {
    return restPaymentService.getAll(params).then((res) => res);
  }
);

export const createPayment = createAsyncThunk(
  'payment/createPayment',
  (data) => paymentService.create(data).then((res) => res)
);

export const updatePayment = createAsyncThunk(
  'payment/updatePayment',
  ({ id, data }) => paymentService.update(id, data).then((res) => res)
);

export const deletePayment = createAsyncThunk(
  'payment/deletePayment',
  (id) => paymentService.delete(id).then((res) => res)
);

export const togglePaymentActive = createAsyncThunk(
  'payment/togglePaymentActive',
  (id) => paymentService.setActive(id).then((res) => res)
);

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchPayments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchPayments.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.payments = normalizePaymentsList(payload);
      state.error = '';
    });
    builder.addCase(fetchPayments.rejected, (state, action) => {
      state.loading = false;
      state.payments = [];
      state.error = action.error.message;
    });

    // rest Payment Service
    builder.addCase(fetchRestPayments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRestPayments.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.payments = normalizePaymentsList(payload);
      state.error = '';
    });
    builder.addCase(fetchRestPayments.rejected, (state, action) => {
      state.loading = false;
      state.payments = [];
      state.error = action.error.message;
    });

    builder.addCase(createPayment.pending, (state) => {
      state.actionLoading = true;
    });
    builder.addCase(createPayment.fulfilled, (state) => {
      state.actionLoading = false;
      state.error = '';
    });
    builder.addCase(createPayment.rejected, (state, action) => {
      state.actionLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(updatePayment.pending, (state) => {
      state.actionLoading = true;
    });
    builder.addCase(updatePayment.fulfilled, (state) => {
      state.actionLoading = false;
      state.error = '';
    });
    builder.addCase(updatePayment.rejected, (state, action) => {
      state.actionLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deletePayment.pending, (state) => {
      state.actionLoading = true;
    });
    builder.addCase(deletePayment.fulfilled, (state) => {
      state.actionLoading = false;
      state.error = '';
    });
    builder.addCase(deletePayment.rejected, (state, action) => {
      state.actionLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(togglePaymentActive.pending, (state) => {
      state.actionLoading = true;
    });
    builder.addCase(togglePaymentActive.fulfilled, (state) => {
      state.actionLoading = false;
      state.error = '';
    });
    builder.addCase(togglePaymentActive.rejected, (state, action) => {
      state.actionLoading = false;
      state.error = action.error.message;
    });
  },
});

export default paymentSlice.reducer;
